export function scrollingNumbers($) {
  jQuery(document).ready(function ($) {
    // Function to animate a single number
    function animateNumber(element, start, end, duration) {
      var range = end - start;
      var startTime = performance.now();
      function update(currentTime) {
        var elapsedTime = currentTime - startTime;
        var progress = Math.min(elapsedTime / duration, 1); // Cap progress at 1
        var currentNumber = Math.floor(start + range * progress);

        // Format the number with commas
        element.textContent = currentNumber.toLocaleString();
        if (progress < 1) {
          requestAnimationFrame(update); // Continue the animation
        }
      }
      requestAnimationFrame(update);
    }
    var statNumbers = document.querySelectorAll('.stat-number');
    if (statNumbers) {
      // Intersection Observer to detect visibility
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var element = entry.target;
            var endValue = parseInt(element.dataset.n, 10); // Get the target number from data-n
            animateNumber(element, 0, endValue, 2000); // Animate from 0 to the target value over 2 seconds
            observer.unobserve(element); // Stop observing once animation is triggered
          }
        });
      }, {
        threshold: 0.5 // Trigger when 50% of the element is visible
      });

      // Observe each stat-number element
      statNumbers.forEach(function (element) {
        observer.observe(element);
      });
    }
  });
}